import { c as _c } from "react/compiler-runtime";
import { Divider, Stack } from '@mui/material';
import type { BackupPolicyType, Condition, Provider, ResourceType } from '@repo/api-gw-sdk';
import type { FilterProperty } from '@/types/advanceFilter';
import { ResourceSelectionDynamicEditor } from './resourceSelectionDynamicEditor';
import type { ResourcesScopeType } from './resourceSelectionDynamicViewer';
import { ResourceSelectionManualOverridesEditor } from './resourceSelectionManualEditor';
export const ResourcesSelectionEditor = t0 => {
  const $ = _c(31);
  const {
    condition,
    setCondition,
    supportedProviders,
    supportedProperties,
    supportedResourceTypes,
    conditionTitle,
    allExcludedDescription,
    allIncludedDescription,
    manualOverridesDescription,
    selectedResourceTypes,
    policyType,
    includedResources,
    excludedResources,
    setIncludedResources,
    setExcludedResources,
    resourcesScopeType,
    setResourcesScopeType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexGrow: 1,
      minHeight: 0,
      gap: "100px",
      justifyContent: "space-between"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== allExcludedDescription || $[2] !== allIncludedDescription || $[3] !== condition || $[4] !== conditionTitle || $[5] !== policyType || $[6] !== resourcesScopeType || $[7] !== selectedResourceTypes || $[8] !== setCondition || $[9] !== setResourcesScopeType || $[10] !== supportedProperties || $[11] !== supportedProviders || $[12] !== supportedResourceTypes) {
    t2 = <ResourceSelectionDynamicEditor condition={condition} setCondition={setCondition} supportedProviders={supportedProviders} supportedProperties={supportedProperties} supportedResourceTypes={supportedResourceTypes} conditionTitle={conditionTitle} allExcludedDescription={allExcludedDescription} allIncludedDescription={allIncludedDescription} resourcesScopeType={resourcesScopeType} setResourcesScopeType={setResourcesScopeType} selectedResourceTypes={selectedResourceTypes} policyType={policyType} />;
    $[1] = allExcludedDescription;
    $[2] = allIncludedDescription;
    $[3] = condition;
    $[4] = conditionTitle;
    $[5] = policyType;
    $[6] = resourcesScopeType;
    $[7] = selectedResourceTypes;
    $[8] = setCondition;
    $[9] = setResourcesScopeType;
    $[10] = supportedProperties;
    $[11] = supportedProviders;
    $[12] = supportedResourceTypes;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  let t4;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: "100px"
    };
    t4 = <Divider orientation="vertical" flexItem={true} />;
    $[14] = t3;
    $[15] = t4;
  } else {
    t3 = $[14];
    t4 = $[15];
  }
  let t5;
  if ($[16] !== includedResources) {
    t5 = includedResources ?? [];
    $[16] = includedResources;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== excludedResources) {
    t6 = excludedResources ?? [];
    $[18] = excludedResources;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== manualOverridesDescription || $[21] !== setExcludedResources || $[22] !== setIncludedResources || $[23] !== supportedProviders || $[24] !== supportedResourceTypes || $[25] !== t5 || $[26] !== t6) {
    t7 = <Stack direction="row" sx={t3}>{t4}<ResourceSelectionManualOverridesEditor description={manualOverridesDescription} includeResources={t5} excludeResources={t6} setIncludedResources={setIncludedResources} setExcludedResources={setExcludedResources} supportedProviders={supportedProviders} supportedResourceTypes={supportedResourceTypes} /></Stack>;
    $[20] = manualOverridesDescription;
    $[21] = setExcludedResources;
    $[22] = setIncludedResources;
    $[23] = supportedProviders;
    $[24] = supportedResourceTypes;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t2 || $[29] !== t7) {
    t8 = <Stack className="mx-[min(100px,5vw)] mt-[min(60px,3vw)]" direction="row" sx={t1}>{t2}{t7}</Stack>;
    $[28] = t2;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
};